@if (!type) {
  <button
    [color]="color"
    [mdePopoverTriggerFor]="createPopover"
    [disabled]="disabled"
    mat-button
    mdePopoverTriggerOn="click">
    {{ text }}
    @if (icon) {
      <mat-icon>{{ icon }}</mat-icon>
    }
  </button>
}

@switch (type) {
  @case ('stroked') {
    <button [color]="color"
      [mdePopoverTriggerFor]="createPopover"
      [disabled]="disabled"
      mat-stroked-button
      mdePopoverTriggerOn="click">
      {{ text }}
      @if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
    </button>
  }
  @case ('raised') {
    <button [color]="color"
      [mdePopoverTriggerFor]="createPopover"
      [disabled]="disabled"
      mat-raised-button
      mdePopoverTriggerOn="click">
      {{ text }}
      @if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
    </button>
  }
  @case ('icon') {
    <button [color]="color"
      [mdePopoverTriggerFor]="createPopover"
      [disabled]="disabled"
      mat-icon-button
      mdePopoverTriggerOn="click">
      {{ text }}
      @if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
    </button>
  }
}

<mde-popover #createPopover="mdePopover"
  class="popover"
  [mdePopoverCloseOnClick]="false"
  [mdePopoverOverlapTrigger]="false"
  mdePopoverPositionY="below">

  <app-layout columnCount="12">
    <app-layout-content>
      <ng-content></ng-content>
    </app-layout-content>
  </app-layout>

</mde-popover>
